export function waitForElementSize(
  getElement: () => HTMLElement | null,
  shouldAbort: () => boolean,
  maxFrames = 20
): Promise<HTMLElement | null> {
  return new Promise((resolve) => {
    let framesLeft = maxFrames;

    const check = () => {
      if (shouldAbort()) {
        resolve(null);
        return;
      }

      const element = getElement();
      if (element && element.clientWidth > 0 && element.clientHeight > 0) {
        resolve(element);
        return;
      }

      if (framesLeft <= 0) {
        resolve(null);
        return;
      }

      framesLeft -= 1;
      requestAnimationFrame(check);
    };

    check();
  });
}
